import Appointments from "./Appointments";
import AppointmentsDetails from "./AppointmentsDetails";
export {Appointments, AppointmentsDetails}